import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { CachingService } from '../services/caching.service';
import { GlobalSearchResponse } from '../models/global-search.model';

export const globalSearchResultsResolver: ResolveFn<
  GlobalSearchResponse | null
> = () => {
  const router = inject(Router);
  const cachingService = inject(CachingService);
  const cachedResults = cachingService.getCache<GlobalSearchResponse>(
    cachingService.globalSearchResultsKey
  );

  if (cachedResults) return cachedResults;

  router.navigateByUrl('/', { replaceUrl: true });
  return null;
};
